import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconSearch = ({
    stroke = '#FC5200'
}) => {
    return (
        <svg
            fill='none'
            style={{ width: '19px', height: '18px' }}
            viewBox='0 0 19 18'
            xmlns='http://www.w3.org/2000/svg'>
            <circle
                cx='7.5'
                cy='7.5'
                r='6.75'
                stroke={stroke}
                strokeWidth='1.5'/>
            <line
                stroke={stroke}
                strokeWidth='1.5'
                x1='12.5303'
                x2='17.5303'
                y1='12.4697'
                y2='17.4697'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    stroke: PropTypes.string,
};

IconSearch.propTypes = propTypes;

export default IconSearch;
